/*
 * @author Andrey Patyuchenko
 * @email  apatyuchenko@atlassian.com
 * @email  andrey.patyuchenko@gmail.com
 * @date   19/10/2022
 */

import React, { useState } from "react";
import { Box, IconButton, Link, ListItemText, Menu, MenuItem, Stack, Tooltip } from "@mui/material";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import Const from "../const.json";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faConfluence, faJira, faSlack } from "@fortawesome/free-brands-svg-icons";
import ContactSupportIcon from "@mui/icons-material/ContactSupport";

interface HelpLink {
	text: string;
	href: string;
	icon: React.ReactElement;
}

const iconSx = { mr: 1, width: "24px" };

const helpLinks: HelpLink[] = [
	{
		text: "Documentation", href: Const.URL_DOCS, icon: <Box component={"span"} sx={iconSx}>
			<FontAwesomeIcon size={"lg"} fixedWidth icon={faConfluence}/>
		</Box>
	},
	{
		text: "Changelog", href: Const.URL_CHANGELOG, icon: <Box component={"span"} sx={iconSx}>
			<FontAwesomeIcon size={"lg"} fixedWidth icon={faConfluence}/>
		</Box>
	},
	{
		text: "Issue Tracker",
		href: Const.URL_ISSUE_TRACKER,
		icon: <Box component={"span"} sx={iconSx}>
			<FontAwesomeIcon size={"lg"} fixedWidth icon={faJira}/>
		</Box>
	},
	{
		text: Const.SLACK_CHANNEL_NAME,
		href: Const.URL_SLACK_CHANNEL,
		icon: <Box component={"span"} sx={iconSx}>
			<FontAwesomeIcon size={"lg"} fixedWidth icon={faSlack}/>
		</Box>
	},
	{
		text: "Contact Us", href: Const.URL_CONTACT, icon: <ContactSupportIcon sx={iconSx}/>
	},
];

export default function HelpMenu() {

	const [ anchorEl, setAnchorEl ] = useState<HTMLButtonElement | null>(null);
	const isOpen = Boolean(anchorEl);

	const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
		setAnchorEl(event.currentTarget);
	};

	const handleClose = () => {
		setAnchorEl(null);
	};

	return (
		<Stack>
			<Tooltip title={"Help"} placement={"right"}>
				<IconButton onClick={handleClick} sx={{ color: "#fff" }} size="large">
					<HelpOutlineIcon/>
				</IconButton>
			</Tooltip>
			<Menu
				anchorEl={anchorEl}
				open={isOpen}
				onClose={handleClose}
				anchorOrigin={{
					vertical: "center",
					horizontal: "right",
				}}
				transformOrigin={{
					vertical: "bottom",
					horizontal: "left",
				}}
			>
				{helpLinks.map(link =>
					<MenuItem
						key={link.text}
						onClick={handleClose}
						component={Link}
						href={link.href}
						target="_blank"
					>
						{link.icon}
						<ListItemText>
							{link.text}
						</ListItemText>
					</MenuItem>
				)}
			</Menu>
		</Stack>
	);

}